import { datadogRum } from '@datadog/browser-rum'

export type Site =
  | 'datadoghq.com'
  | 'us3.datadoghq.com'
  | 'us5.datadoghq.com'
  | 'datadoghq.eu'
  | 'ddog-gov.com'
  | 'ap1.datadoghq.com'

export default defineNuxtPlugin((nuxtApp) => {
  const {
    datadogApplicationId,
    datadogClientToken,
    datadogSite,
    datadogService,
    environment,
    version,
  } = nuxtApp.$config.public

  try {
    if (!datadogApplicationId) {
      return
    }

    const datadog = datadogRum.init({
      applicationId: datadogApplicationId,
      clientToken: datadogClientToken,
      site: datadogSite as Site,
      service: datadogService,
      env: environment,
      version: version.split('/').pop(),
      sessionSampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      // forward dd traceid when fetches are to the following urls
      allowedTracingUrls: [(url) => url.includes('airalo.com')],
    })
    nuxtApp.vueApp.provide('datadog', datadog)
  } catch (err) {
    console.error('Not connected to Datadog', err)
  }
})
